import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catMotivosLicencia } from "../../Categorias y Estados/catMotivosLicencia";
import { Personal } from "../Personal";
import { PersonalLicenciasFilters } from "../PersonalLicenciasFilters/PersonalLicenciasFilters";

const columns = () =>
(
    {
        c_personallicencia_id: new EntityColumn<string>({ name: 'c_personallicencia_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Licencia Id' }),
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.FK, prompt: 'Personal Id' }),
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Fileprocess Id' }),
        c_motivoliciencia_id: new EntityColumn<string>({ name: 'c_motivoliciencia_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Motivo' }),
        dt_fecha_desde: new EntityColumn<Date>({ name: 'dt_fecha_desde', type: 'datetime', flags: c.Edit, prompt: 'Fecha Desde' }),
        dt_fecha_hasta: new EntityColumn<Date>({ name: 'dt_fecha_hasta', type: 'datetime', flags: c.Edit, prompt: 'Fecha Hasta' }),
        vc_observaciones: new EntityColumn<string>({ name: 'vc_observaciones', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciones' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        plli_brwStandard: { name: 'plli_brwStandard', keyMappings: { c_personallicencia_id: 0 } },
        plli_brwHistorial: {
            name: 'plli_brwHistorial',
            keyMappings: { c_personallicencia_id: 0, c_personal_id: 6 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalLicenciasFilters(client, parentKeys)
        }
    }
)


const lookups = () =>
(
    {
        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
        'MotivosLicencia': {
            name: 'MotivosLicencia',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catMotivosLicencia(client, parentKeys)
        }
    }
)

export class PersonalLicenciasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('PersonalLicencias');
    }
}